module.exports = __webpack_public_path__ + "static/media/plan-B1a-desktop-tc.05afe24d.png";